import { render, staticRenderFns } from "./base-text-container.vue?vue&type=template&id=68c3142f"
import script from "./base-text-container.vue?vue&type=script&setup=true&lang=js"
export * from "./base-text-container.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-text-container.vue?vue&type=style&index=0&id=68c3142f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports